// --------------------------------------------------------------------------
// filmPopup.js
// --------------------------------------------------------------------------
// Uses magnific popup to fetch a vimeo player and display in a lightbox
// --------------------------------------------------------------------------

EC.filmPopup = function () {

    'use strict';

    function init () {
        $('.js-film-popup').magnificPopup({type: 'iframe'});
    }

    return {
        init: init
    };

}();